/**
 * Parks the payload wizards outside Swagger remounts, then places them
 * after Authorize (.scheme-container) and before Default operations.
 * Instruction used: scope-discipline.instructions.md
 */

export const WIZARD_ANCHOR_ID = 'premium-quote-wizard-anchor'
export const PROPOSAL_WIZARD_ANCHOR_ID = 'proposal-submission-wizard-anchor'
export const LIXI_PREMIUM_WIZARD_ANCHOR_ID = 'lixi-premium-quote-wizard-anchor'
export const LIXI_PROPOSAL_WIZARD_ANCHOR_ID = 'lixi-proposal-submission-wizard-anchor'

export function restorePremiumQuoteWizardAnchor(section) {
  restoreWizardAnchor(WIZARD_ANCHOR_ID, section)
}

export function restoreProposalWizardAnchor(section) {
  restoreWizardAnchor(PROPOSAL_WIZARD_ANCHOR_ID, section)
}

export function placePremiumQuoteWizardAnchor(swaggerRoot) {
  return placeWizardAnchor(WIZARD_ANCHOR_ID, swaggerRoot)
}

export function placeProposalWizardAnchor(swaggerRoot) {
  return placeWizardAnchor(PROPOSAL_WIZARD_ANCHOR_ID, swaggerRoot)
}

export function startPremiumQuoteWizardPlacement(swaggerRoot) {
  startWizardPlacement(WIZARD_ANCHOR_ID, swaggerRoot)
}

export function startProposalWizardPlacement(swaggerRoot) {
  startWizardPlacement(PROPOSAL_WIZARD_ANCHOR_ID, swaggerRoot)
}

export function restoreLixiPremiumQuoteWizardAnchor(section) {
  restoreWizardAnchor(LIXI_PREMIUM_WIZARD_ANCHOR_ID, section)
}

export function restoreLixiProposalWizardAnchor(section) {
  restoreWizardAnchor(LIXI_PROPOSAL_WIZARD_ANCHOR_ID, section)
}

export function startLixiPremiumQuoteWizardPlacement(swaggerRoot) {
  startWizardPlacement(LIXI_PREMIUM_WIZARD_ANCHOR_ID, swaggerRoot)
}

export function startLixiProposalWizardPlacement(swaggerRoot) {
  startWizardPlacement(LIXI_PROPOSAL_WIZARD_ANCHOR_ID, swaggerRoot)
}

function restoreWizardAnchor(anchorId, section) {
  const anchor = document.getElementById(anchorId)
  const container = document.getElementById('swagger-ui-container')
  if (!anchor || !container || !section) return
  if (anchor.parentNode !== section || anchor.nextSibling !== container) {
    section.insertBefore(anchor, container)
  }
}

function placeWizardAnchor(anchorId, swaggerRoot) {
  const anchor = document.getElementById(anchorId)
  if (!anchor || !swaggerRoot) return false

  const scheme = swaggerRoot.querySelector('.scheme-container')
  if (!scheme || !scheme.parentNode) return false
  if (scheme.nextSibling !== anchor) {
    scheme.parentNode.insertBefore(anchor, scheme.nextSibling)
  }
  return true
}

function startWizardPlacement(anchorId, swaggerRoot) {
  if (!document.getElementById(anchorId)) return
  if (placeWizardAnchor(anchorId, swaggerRoot)) return
  if (!swaggerRoot || swaggerRoot.dataset.heliaWizardPlaceObserver === 'true') return
  swaggerRoot.dataset.heliaWizardPlaceObserver = 'true'
  const observer = new MutationObserver(function () {
    if (placeWizardAnchor(anchorId, swaggerRoot)) {
      observer.disconnect()
      swaggerRoot.dataset.heliaWizardPlaceObserver = 'false'
    }
  })
  observer.observe(swaggerRoot, { childList: true, subtree: true })
}
